import classNames from 'classnames';
import NextImage from 'next/image';
import style from './SliderHand.module.scss';

const SliderHand = ({ orientation, hidden }) => {
  return (
    <div
      style={{ display: hidden ? 'none' : '' }}
      className={classNames(style.sliderHand, {
        [style.__right]: orientation === 'right',
        [style.__left]: orientation !== 'right',
      })}
    >
      <div className={classNames(style.sliderHandWrapper, style.sliderHandWrapper_visible)}>
        <NextImage
          width={55}
          height={52}
          src='https://static.tildacdn.com/tild3834-6331-4462-b361-316363316363/hand.svg'
          className={style.sliderHand__hand}
          alt='Указатель слайдера'
        />
      </div>
    </div>
  );
};

export default SliderHand;
